import React from 'react';
interface ProgressBarProps {
  percent: number;
  label: string;
  complete?: boolean;
  className?: string;
}

/** Grey when untouched, accent while in progress, white once complete. */
export function ProgressBar({
  percent,
  label,
  complete = false,
  className = ''
}: ProgressBarProps) {
  const value = Math.max(0, Math.min(100, percent));
  return <div role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={value} className={`h-1.5 w-full overflow-hidden rounded-full bg-charcoal ${className}`} data-id="element-504" data-mp="29vo6oxqyw4hl">
      <div className={`h-full rounded-full transition-[width] duration-300 ease-out ${complete ? 'bg-ink' : 'bg-gold'}`} style={{
      width: `${value}%`
    }} data-id="element-505" data-mp="2nm1gl5nf5t9k" />
    </div>;
}